export default {"src":"/_next/static/media/destination-experts.78a1232f.svg","height":44,"width":44,"blurWidth":0,"blurHeight":0};